import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetModulesListQuery } from '../../../api/queries/getModulesList';
import { ModuleType } from '../../../api/types';
import { useCompanyContext } from '../../../components/contexts/CompanyContextManager';
import LoadingElement from '../../../components/LoadingElement';
import ConsolePageWithHeader from '../../../layouts/ConsoleLayout/ConsolePageWithHeader';
import TradeInList from './TradeInList';
import useDownload from './useDownload';

const TradeInListPage = () => {
    const { t } = useTranslation('tradeInList');
    const { companies } = useCompanyContext();

    const { data, loading } = useGetModulesListQuery({
        fetchPolicy: 'cache-and-network',
        variables: {
            filter: {
                companyIds: companies.map(company => company.id),
                moduleType: ModuleType.TradeInModule,
            },
        },
    });

    const moduleIds = useMemo(() => (data?.modules?.items || []).map(module => module.id), [data]);

    const { render } = useDownload();

    if (loading) {
        return <LoadingElement />;
    }

    return (
        <ConsolePageWithHeader extra={render()} title={t('tradeInList:title')}>
            <TradeInList moduleIds={moduleIds} />
        </ConsolePageWithHeader>
    );
};

export default TradeInListPage;
